<template>
	<router-view />
</template>
<script>
export default {
	components: {},
};
</script>
<style lang="scss">
@import "./scss/main";
</style>
